import defaultView from '../views/default';
import homeView from '../views/template-home';

export default [homeView, defaultView];
